package ru.villawonka.app.data.entity.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.AccommodationTypeDomain

@Serializable
enum class AccommodationTypeDto {
    @SerialName("villa") VILLA,
    @SerialName("guesthouse") GUESTHOUSE,
    @SerialName("room") ROOM,
    @SerialName("apartment") APARTMENT
}

fun AccommodationTypeDto.toDomain() = when (this) {
    AccommodationTypeDto.ROOM -> AccommodationTypeDomain.ROOM
    AccommodationTypeDto.APARTMENT -> AccommodationTypeDomain.APARTMENT
    AccommodationTypeDto.VILLA -> AccommodationTypeDomain.VILLA
    AccommodationTypeDto.GUESTHOUSE -> AccommodationTypeDomain.GUESTHOUSE
}

fun AccommodationTypeDomain.toDto() = when (this) {
    AccommodationTypeDomain.ROOM -> AccommodationTypeDto.ROOM
    AccommodationTypeDomain.APARTMENT -> AccommodationTypeDto.APARTMENT
    AccommodationTypeDomain.VILLA -> AccommodationTypeDto.VILLA
    AccommodationTypeDomain.GUESTHOUSE -> AccommodationTypeDto.GUESTHOUSE
}